import React, { useState } from 'react';
import { Search } from 'lucide-react';
import ConversationList from './ConversationList';

const ChatSidebar = ({ users }) => {
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <div className="w-80 flex flex-col border-r border-gray-200 bg-white h-full">
      <div className="p-4 border-b border-gray-100">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">Messages</h2>
        <div className="relative">
          <input
            type="text"
            placeholder="Search users or messages..."
            className="w-full pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:bg-white transition-colors"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Search className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" />
        </div>
      </div>
      
      <div className="flex-1 overflow-y-auto">
        <ConversationList users={users} searchTerm={searchTerm} />
      </div>
    </div>
  );
};

export default ChatSidebar;
